module.exports = __webpack_public_path__ + "static/img/8.79efe67.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/sp/8.png
// module id = FZdi
// module chunks = 0